import { useContext, useEffect, useState } from "react";
import { UserContext } from "components/context/UserProvider";
import ListShort from "components/ui/atoms/ListShort";
import NoteListItemShort from "models/notes/NoteListItemShort";
import { useAllNote } from "models/notes/apiNote";
import { useModal } from "@ebay/nice-modal-react";

const NoteWidget = ({ companyId, peopleId }) => {
  const [state, setState] = useState({
    offset: 0,
  });
  const [fetchParams, setFetchParams] = useState(null);
  const { data: notes, status, refetch } = useAllNote(fetchParams);
  const { user } = useContext(UserContext);
  const noteModal = useModal("NoteDrawer");

  useEffect(() => {
    setFetchParams({
      company: [companyId],
      people: [peopleId],
      ...state,
      ordering: "-created_at",
    });
  }, [companyId, peopleId, state]);

  return (
    <>
      <ListShort
        title="Notes"
        resource={notes}
        resourceStatus={status}
        state={state}
        setState={setState}
        ListItemComponent={NoteListItemShort}
        primaryClick={(note) =>
          noteModal
            .show({
              objectId: note.id,
              formType: "update",
              values: notes?.results.map((n) => n.id),
            })
            .then(refetch)
        }
        addResource={() =>
          noteModal.show({
            formType: "create",
            initialValues: {
              owner: user.id,
              owner_detail: user,
              companies_ids: companyId ? [companyId] : [],
              people_ids: peopleId ? [peopleId] : [],
            },
          })
        }
        emptyMessage="No Notes"
        pagination
      />
    </>
  );
};

export default NoteWidget;
